module.exports = __webpack_public_path__ + "img/auth2.76fab3fa.png";